import { useEffect, useState } from 'react';
import { useAuthStore } from '@/stores';

/**
 * Runs the session check once per mount and reports whether it is still
 * pending. The network call is skipped when the store already holds a
 * session verified in this app session, so moving between guarded routes
 * neither re-fetches /auth/me nor flashes the loader. A server-side role
 * change therefore takes effect on token expiry or reload; until then the
 * API answers with 403.
 */
export function useSessionCheck(): boolean {
  const [isChecking, setIsChecking] = useState(() => {
    const { isAuthenticated, authChecked } = useAuthStore.getState();
    return !(isAuthenticated && authChecked);
  });

  useEffect(() => {
    const { isAuthenticated, authChecked, checkAuth } = useAuthStore.getState();
    if (isAuthenticated && authChecked) {
      return;
    }

    let active = true;
    void checkAuth().then(() => {
      if (active) {
        setIsChecking(false);
      }
    });
    return () => {
      active = false;
    };
  }, []);

  return isChecking;
}
